export enum LimaWorkstationType {       
    RXSatellitBlockad = -20,      
    RXSingelBlockad = -10,      
    RXBlockad = -2,      
    PackBlockad = -1,      
    unknown = 0,      
    Pack = 1,      
    RX = 2,
    RXAuto = 3,      
    RXsingel = 10,      
    RXSatellit = 20,      
    AFrame = 30,      
    AutoPackSmall = 33,      
    AutoPackMedium = 36,      
    Bud = 40,      
    TungSingel = 50,      
    RXKyl = 53,      
    AutoPackLarge = 60,      
    AutoPackXLarge = 70,      
    AutoPackMixedSmall = 73,
    AutoPackWestMixedSmall = 74,    
    AutoPackMixedMedium = 76,
    AutoPackWestMixedMedium = 77,     
    AFrameAll = 79,      
    LidingoTransit = 83,      
    LidingoExpress = 86,      
    Kontrollstation = 99,
  }
  
  